<template>
  <section v-if="hasContent(context.item.modulinfobildtext3spaltigueberschrift)" :class="sectionClass">
    <div class="container">
      <h2 class="section-title info-3c-image__title">
        <span class="headline">{{ context.item.modulinfobildtext3spaltigueberschrift }}</span>
      </h2>

      <div class="grid-auto grid-auto-3c">
        <div v-for="(teaser, i) in filteredTeasers" :key="i" class="grid-c lc-m">
          <div class="item-vertical" >
            <figure class="item-vertical__figure">
              <img :src="getField(`modulinfobildtext3spaltigbild${i+1}`).url" 
                  :alt="getField(`modulinfobildtext3spaltigbild${i+1}`).alt" 
                  class="item-vertical__img"
              />
            </figure>
            <h3 class="item-vertical__title">
              <span class="headline">{{ getField(`modulinfobildtext3spaltiguntertitel${i+1}`) }}</span>
            </h3>
            <div v-html="getField(`modulinfobildtext3spaltigtext${i+1}`)"></div>
          </div>
        </div>
          
      </div>
      
      <div class="center" v-if="hasContent(context.item.modulinfobildtext3spaltigbutton.text)">
        <a class="button button--cat1 button--large" :href="context.item.modulinfobildtext3spaltigbutton.url" :target="context.item.modulinfobildtext3spaltigbutton.target">{{ context.item.modulinfobildtext3spaltigbutton.text }}</a>
     </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ModulInfoBildText3Spaltig',
  props: {
    context: {
      type: Object,
    },
  },
  computed: {
    filteredTeasers() {
      // Erstellt ein Array von 1 bis 15 und filtert nur die aus, die einen Untertitel haben
      return Array.from({ length: 15 }, (_, i) => {
        const index = i + 1;
          return {
          subtitle: this.getField(`modulinfobildtext3spaltiguntertitel${index}`),
          text: this.getField(`modulinfobildtext3spaltigtext${index}`),
          imgSrc: this.getField(`modulinfobildtext3spaltigbild${index}`).url,
          imgAlt: this.getField(`modulinfobildtext3spaltigbild${index}`).alt
        };
      }).filter(teaser => this.hasContent(teaser.subtitle)); // Nur die Elemente behalten, die einen Untertitel haben
    },

    sectionClass() {
      const styleField = this.context.item.modulinfobildtext3spaltigstyle;

      // Überprüfen, ob das Feld existiert und einen Wert hat
      if (styleField && styleField.trim()) {
        return `outer info-3c-image section-styling-${styleField}`;
      }

      // Standardklasse zurückgeben, wenn kein Feld vorhanden ist
      return 'outer info-3c-image section-styling-0';
    },
  },
  methods: {
    getField(field) {
      const fullPath = `${field}`;
      return this.context.item[fullPath] || '';
    },

    hasContent(fieldContent) {
      return fieldContent && fieldContent.trim().length > 0;
    },  
  },
};
</script>